// Centralne stałe gry – jedna definicja liczb magicznych
export const PASSAGE_ZONES = [
  { min: 200, max: 300 },
  { min: 700, max: 800 },
] as const;

export const WIN_SCORE = 1000;
export const FIRST_ENTRY_MIN = 50;
export const MIN_THREE_DICE = 15; // minimalny dodatni wynik przed 900 pkt
export const THREE_DICE_THRESHOLD = 900; // od tego wyniku można schodzić poniżej 15

export const PENALTIES = {
  FIRST_ROLL_ZERO: -50,
  OVERTAKE: -50,
};

export const BONUSES = {
  OVERTAKE: 50,
};

// Strefy – ukryte, losowane co grę odcinki trasy dające premię lub karę.
// Drabinka jest stała: im mocniejszy efekt, tym węższa (trudniejsza do trafienia) strefa.
export const ZONE_TIERS = [
  { tier: 1, points: 60, width: 5 },
  { tier: 2, points: 40, width: 10 },
  { tier: 3, points: 20, width: 15 },
] as const;

export const ZONE_SNAP = 5; // każdy osiągalny wynik jest wielokrotnością 5
export const ZONE_MIN_START = 100; // poniżej pierwszego wejścia strefy są martwe
export const ZONE_MAX_END = 895; // poniżej progu 900: wyżej kary i wyprzedzenia są wyłączone
export const ZONE_MIN_GAP = 25; // strefy mogą być blisko, ale nie mogą się stykać
/**
 * Twardy bezpiecznik długości łańcucha stref. Wykrywanie pętli po powtórzonym wyniku
 * kończy łańcuch samo, a trafialnych wyników jest w sumie 18 (dwa rodzaje × 2+3+4 na
 * poziom), więc bez cyklu nie da się przekroczyć 19 ogniw. Limit jest wyłącznie po to,
 * żeby przyszła zmiana drabinki nie mogła zawiesić rozliczenia tury.
 */
export const ZONE_MAX_CHAIN_LINKS = 24;

// Inscenizacja trafienia: marker najpierw dojeżdża na wynik z rzutu, tam odsłania się
// strefa, i dopiero po pauzie marker skacze na wynik po jej efekcie.
export const ZONE_STAGE_ARRIVAL_MS = 1000; // zgrane z czasem przejazdu markera
export const ZONE_STAGE_HOLD_MS = 600; // pauza na odsłonięcie strefy przed drugim skokiem
// Kolejne ogniwa łańcucha odgrywamy szybciej – gracz zna już rytm, a pełne tempo
// przy kilku skokach ciągnęłoby turę w nieskończoność.
export const ZONE_STAGE_JUMP_MS = 400; // przejazd między strefami w łańcuchu
// Długi łańcuch (rzadkość, ale możliwy przy pętli) leci w tempie ekspresowym,
// żeby najgorszy przypadek nie zamienił się w kilkunastosekundowy pokaz.
export const ZONE_STAGE_LONG_CHAIN_LINKS = 4;
export const ZONE_STAGE_JUMP_FAST_MS = 220;
export const ZONE_STAGE_HOLD_FAST_MS = 260;

export const HISTORY_LIMIT = 1000; // local UI history buffer (client-side only)

// Usunięto obsługę migracji – brak SCHEMA_VERSION

// Walidacja nazw graczy
export const PLAYER_NAME_MIN_LEN = 2;
export const PLAYER_NAME_MAX_LEN = 20;
export const PLAYER_MAX_COUNT = 16;
// eslint-disable-next-line no-misleading-character-class -- intentionally allows emoji sequences and modifiers
export const PLAYER_NAME_REGEX = /^[\p{L}\p{N} _\-\p{Extended_Pictographic}\u200D\uFE0F\u{1F3FB}-\u{1F3FF}]+$/u; // litery (w tym PL), cyfry, spacje, _-, emoji

// Limity punktów w pojedynczym wpisie (delta)
export const SCORE_DELTA_MIN = -400;
export const SCORE_DELTA_MAX = 4000;

// Rapid (time-pressure) mode constants
export const RAPID_FREE_THRESHOLD_MS = 10_000;  // ms free before penalty starts
export const RAPID_BASE_BLOCK_MS = 5_000;       // default penalty block size (ms)
export const RAPID_MIN_BLOCK_MS = 2_000;        // minimum block size after full scaling
export const RAPID_PENALTY_STEP = -5;           // points deducted per block
export const RAPID_PENALTY_FLASH_MS = 1_050;
